module.exports = {
      id: "comm-video-usage",
      viewBox: "0 0 276.069 41.984",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-video",
      toString: function () {
        return this.url;
      }
    }